module.exports = __webpack_public_path__ + "static/media/connectdevelop.0a481057.svg";